import React, { useState, useContext } from 'react'
import Moment from 'moment'
import { Link } from 'react-router-dom'
import styled from 'styled-components/macro'

import LogError from 'actions/LogError'
import LogEvent from 'actions/LogEvent'
import deleteBoard from 'actions/deleteBoard'
import updateBoard from 'actions/updateBoard'
import duplicateBoard from 'actions/duplicateBoard'
import ShareBoardModal from 'views/board/sharing/ShareBoardModal'
import MoveBoardModal from 'views/board/sharing/MoveBoardModal'
import Dropdown from 'views/_components/Dropdown'
import BubbleHeadList from 'views/_components/BubbleHeadList'
import { DebugContext } from 'views/DebugState'
import {
  DropdownMenuAction,
  DropdownUpperRightWrapper,
  DropdownToggleWrapper,
} from 'styles/dropdown'
import {
  Button,
} from 'styles/buttons'

const BoardListItem = ({
  loading,
  board,
  orgRef,
  boardMembers,
}) => {

  const debugging = useContext(DebugContext)

  const [ isSharingBoard, setIsSharingBoard ] = useState(false)
  const [ isMovingBoard, setIsMovingBoard ] = useState(false)

  if (loading) {
    return <BoardListItemWrapper key={board.id} to={`/b/${orgRef.id}/${board.id}`}>
      Loading...
    </BoardListItemWrapper>
  }

  return <BoardListItemWrapper key={board.id} to={`/b/${orgRef.id}/${board.id}`}>
    <div>
      <BoardTitle>{board.name || 'Unnamed board'}</BoardTitle>
      <BoardSubtitle>
        {Moment(board.createdOn.toDate()).calendar()}
      </BoardSubtitle>
      <BubbleHeadList users={boardMembers} />
    </div>

    <div>
      <Button
        small
        secondary="secondary"
        style={{marginRight: '.5rem'}}
        onClick={event => {
          event.stopPropagation()
          event.preventDefault()
          setIsSharingBoard(true)
        }}
      >
        Export
      </Button>
      <Button
        small
        style={{marginRight: '1rem'}}
      >
        Open
      </Button>
    </div>

    <DropdownUpperRightWrapper>
      <Dropdown
        toggle={<DropdownToggleWrapper><i className="material-icons-round">more_vert</i></DropdownToggleWrapper>}
      >
        { ({close}) => {
          return <div>
            
            <DropdownMenuAction onClick={event => {
              event.preventDefault()
              close()
              const boardRef = orgRef.collection('boards').doc(board.id)
              LogEvent('duplicate-board')
              duplicateBoard({ orgRef, boardRef })
                .catch( error => LogError('duplicate this board', error) )
            }}>
              <i className="material-icons-round">content_copy</i>
              Duplicate board
            </DropdownMenuAction>
            
            { debugging &&
              <DropdownMenuAction onClick={event => {
                event.preventDefault()
                close()
                setIsMovingBoard(true)
              }}>
                <i className="material-icons-round">input</i>
                Move board
              </DropdownMenuAction>
            }
            
            <DropdownMenuAction onClick={event => {
              event.preventDefault()
              const name = window.prompt(`What do you want to call this board?`, board.name)
              if (name === null) {
                return
              }
              LogEvent('rename-board')
              const boardRef = orgRef.collection('boards').doc(board.id)
              updateBoard(boardRef, { name })
                .then(close)
                .catch( error => LogError('rename this board', error) )
            }}>
              <i className="material-icons-round">create</i>
              Rename board
            </DropdownMenuAction>

            <DropdownMenuAction destructive="destructive" onClick={event => {
              event.preventDefault()
              const reallyDelete = window.confirm(`Are you sure you want to delete this board? You can't undo this.`)
              if (reallyDelete) {
                LogEvent('delete-board')
                const boardRef = orgRef.collection('boards').doc(board.id)
                deleteBoard(boardRef)
                  .catch( error => LogError('delete this board', error) )
              }
            }}>
              <i className="material-icons-round">delete_outline</i>
              Delete board
            </DropdownMenuAction>
          </div>
        }}
      </Dropdown>
    </DropdownUpperRightWrapper>

    { isSharingBoard &&
      <ShareBoardModal
        board={board}
        boardOrgId={orgRef.id}
        isFacilitator={true}
        onClose={ () => setIsSharingBoard(false) }
      />
    }
    
    { isMovingBoard &&
      <MoveBoardModal
        board={board}
        orgRef={orgRef}
        onClose={ () => setIsMovingBoard(false) }
      />
    }
    
  </BoardListItemWrapper>
}

const BoardListItemWrapper = styled(Link)`
  padding: 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  min-height: 8rem;
  position: relative;

  background: white;
  box-shadow: 0 2px 6px var(--shadow);
  border: 1px solid var(--gray-90);
  
  display: grid;
  grid-template-columns: auto max-content;
  grid-column-gap: 1rem;
  align-items: center;

  cursor: pointer;
  
  &:hover {
    border: 1px solid var(--gray-80);
  }

  @media(max-width: 599px) {
    grid-template-columns: 1fr;
    grid-row-gap: 1rem;
  }
`
const BoardTitle = styled.div`
  font-family: var(--font-family-sans);
  font-family: var(--font-family-sans-display);
  color: var(--text-primary);
  font-weight: 600;
  font-size: var(--l);
  line-height: 1.1;
`
const BoardSubtitle = styled.div`
  color: var(--text-secondary);
  font-size: var(--s);
  margin-bottom: 1rem;
`

export default BoardListItem
